import { render, staticRenderFns } from "./RedPacketSendDialog.vue?vue&type=template&id=67a0f106&scoped=true"
import script from "./RedPacketSendDialog.vue?vue&type=script&lang=js"
export * from "./RedPacketSendDialog.vue?vue&type=script&lang=js"
import style0 from "./RedPacketSendDialog.vue?vue&type=style&index=0&id=67a0f106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0f106",
  null
  
)

export default component.exports